import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { PageHeader } from "@/components/common/PageHeader"
import { Badge } from "@/components/ui/badge"
import { useAuthStore } from "@/features/auth/store"

export function MePage() {
  const user = useAuthStore((s) => s.user)
  if (!user) return null

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Mój profil"
        subtitle="Twoje dane konta i poziom dostępu"
      />
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            {user.fullName}
            {user.superuser && <Badge>superuser</Badge>}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm">
          <div className="flex justify-between border-b py-2">
            <span className="text-muted-foreground">ID użytkownika</span>
            <span className="font-mono">{user.id}</span>
          </div>
          <div className="flex justify-between py-2">
            <span className="text-muted-foreground">Poziom dostępu</span>
            <span>{user.superuser ? "Superuser" : "Standardowy"}</span>
          </div>
          <p className="pt-3 text-xs text-muted-foreground">
            CRM EasyEko będzie używać własnego modelu uprawnień. Halocrm permissions nie są tu eksponowane.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
